var dom = {};

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var domCache = require('dom-cache');

var bodyStateDetection = require('body-state-detection');

var setupDom = function() {

	dom.hdr = domCache.document.find('.footer__hdr');
	dom.linkSets = domCache.document.find('.footer__link-set');

};

var addEventHandlers = function() {

	domCache.document.on('device_state_changed', onDeviceStateChanged);
	dom.hdr.on('click', onHdrClicked);

};

var onHdrClicked = function() {

	var $target = $(this).parents('.footer__menu-container').find('.footer__link-set');

	if ($target.is(':visible')) {

		$target.hide();

	} else {

		dom.linkSets.hide();

		$target.show();

	}


};

var onDeviceStateChanged = function(e) {

	if (e.newState.indexOf('large') >= 0) {
		dom.linkSets.show();
	} else {
		dom.linkSets.hide();
	}

};

var init = function() {

	setupDom();

	addEventHandlers();

};

module.exports = {
	init: init
}